import { NgModule } from '@angular/core';
import { DayLettersPipe, DaySchedulePipe } from './day-letters.pipe';
import { ParagraphsPipe } from './paragraph.pipe';
import { SafePipe } from './safe-html.pipe';

@NgModule({
  declarations: [DayLettersPipe, DaySchedulePipe, ParagraphsPipe, SafePipe],
  exports: [DayLettersPipe, DaySchedulePipe, ParagraphsPipe, SafePipe],
})
export class PipesModule {}
